// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"159":"40b74181b98c3d66","717":"f32b7b44af56ffcf","896":"1fa6d821611c8098"}[chunkId] + ".js";
};